import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  type MembersInitialState,
  type SetMembersPayload,
  type SetRoleOptionsPayload,
} from './types';

const initialState: MembersInitialState = {
  members: {},
  roleOptions: [],
};

export const membersSlice = createSlice({
  name: 'members',
  initialState,
  reducers: {
    setMembers: (
      state,
      { payload: { propertyId, members } }: PayloadAction<SetMembersPayload>,
    ) => {
      state.members[propertyId] = members;
    },
    setRoleOptions: (
      state,
      { payload }: PayloadAction<SetRoleOptionsPayload>,
    ) => {
      state.roleOptions = payload;
    },
  },
});

export const { reducer: membersReducer } = membersSlice;
